import { SUCCESS_MESSAGES } from '@/enums/success-messages';

// eslint-disable-next-line
export const onInstallationSaveSuccess = {
  methods: {
    onInstallationSaveSuccess(response) {
      if (response.status === 200) {
        this.$notify.success({
          title: SUCCESS_MESSAGES.SEND_REQUEST_SUCCESS_MESSAGE,
          showClose: true,
          type: 'success',
        });
        this.$router.push({
          name: 'requests.detail',
          params: {
            id: response.data.id,
          },
        });
      }
    },
  },
};
